import type { UppFloorPlanTheme } from '../plan/floor-plan-theme';
import { registerFloorPlanShapePainter } from './paint';

const WINDOW_WALL_CM = 10;
const WINDOW_JAMB_CM = 8;

/** v3 `_drawWindow` — thin wall strip; `double` adds vertical mullion. */
function addWindowWallGeometry(
  K: any,
  parent: any,
  openW: number,
  theme: UppFloorPlanTheme,
  scalePxPerCm: number,
  mode: 'single' | 'double',
): void {
  const H = Math.max(3, WINDOW_WALL_CM * scalePxPerCm + 2);
  const ww = Math.max(2, WINDOW_JAMB_CM * scalePxPerCm);
  const strokeWall = theme.elementStroke;
  const midW = theme.elementStrokeWidth * 1.2;

  parent.add(
    new K.Rect({
      x: 0,
      y: 0,
      width: openW,
      height: H,
      fill: theme.roomFill,
      listening: false,
    }),
  );

  parent.add(
    new K.Rect({
      x: 0,
      y: 0,
      width: ww,
      height: H,
      fill: 'rgba(0,0,0,0)',
      stroke: strokeWall,
      strokeWidth: theme.elementStrokeWidth,
      listening: false,
    }),
  );
  parent.add(
    new K.Rect({
      x: openW - ww,
      y: 0,
      width: ww,
      height: H,
      fill: 'rgba(0,0,0,0)',
      stroke: strokeWall,
      strokeWidth: theme.elementStrokeWidth,
      listening: false,
    }),
  );

  parent.add(
    new K.Line({
      points: [ww, H / 2, openW - ww, H / 2],
      stroke: strokeWall,
      strokeWidth: midW,
      listening: false,
    }),
  );

  if (mode === 'double') {
    parent.add(
      new K.Line({
        points: [openW / 2, 0, openW / 2, H],
        stroke: strokeWall,
        strokeWidth: midW * 0.85,
        listening: false,
      }),
    );
  }
}

registerFloorPlanShapePainter('window:SINGLE', (ctx) => {
  const { K, group, widthPx: openW, theme, scalePxPerCm } = ctx;
  addWindowWallGeometry(K, group, openW, theme, scalePxPerCm, 'single');
});

registerFloorPlanShapePainter('window:DOUBLE', (ctx) => {
  const { K, group, widthPx: openW, theme, scalePxPerCm } = ctx;
  addWindowWallGeometry(K, group, openW, theme, scalePxPerCm, 'double');
});
